// Join endpoint events to windows between identified conversation observations.
// The first observation has no lower bound and receives no attributed events.
export function joinEventsToClock(clock, events) {
  const byRung = new Map();
  for (const r of clock || []) byRung.set(r.fromTurn, []);
  for (const e of events || []) {
    if (!e || !Number.isFinite(e.ts)) continue;
    for (const r of clock || []) {
      if (r.startTs == null || r.endTs == null) continue;
      if (e.ts > r.startTs && e.ts <= r.endTs) {
        byRung.get(r.fromTurn).push(e);
        break;
      }
    }
  }
  for (const list of byRung.values()) list.sort((a, b) => a.ts - b.ts);
  return byRung;
}
